import { useState } from "react";
import styled, { px } from "livemap-ui";

import { createSMSChallenge, verifyChallenge } from "../api/sign-in";
import { Slider } from "./Slider";
import { useAddToast } from "../contexts/toast";
import { CellPhoneForm } from "./CellPhoneForm";
import { VerificationForm } from "./VerificationForm";

export function SMSSignIn() {
  const addToast = useAddToast();
  const [isSending, setIsSending] = useState(false);
  const [challengeId, setChallengeId] = useState(-1);
  const [step, setStep] = useState(0);

  const startChallenge = async (dialingCode: string, cellPhone: string) => {
    setIsSending(true);

    const response = await createSMSChallenge(dialingCode, cellPhone);

    setIsSending(false);

    if (!response.succeeded && response.message) {
      addToast({
        id: "sms-challenge-error",
        type: "danger",
        title: "Sorry!",
        text: response.message,
      });
    } else if (!response.succeeded && !response.message) {
      addToast({
        id: "sms-challenge-error",
        type: "danger",
        title: "Oh no!",
        text: "Something unexpected happened",
      });
    } else {
      setChallengeId(response.challengeId);
      setStep(step + 1);
    }
  };

  const completeChallenge = async (verificationCode: string) => {
    setIsSending(true);

    const response = await verifyChallenge(challengeId, verificationCode);

    setIsSending(false);

    if (!response.succeeded && response.message) {
      addToast({
        id: "sms-verification-error",
        title: "Sorry",
        text: response.message,
        type: "danger",
      });
    } else if (!response.succeeded && !response.message) {
      addToast({
        id: "unknown-sms-verification-error",
        title: "Oops!",
        text: "Unknown error",
        type: "danger",
      });
    } else {
      addToast({
        id: "sms-challenge-success",
        title: "Success",
        text: "We're logging you in!",
        type: "success",
      });

      setTimeout(() => window.location.reload(), 2000);
    }
  };

  return (
    <Slider step={step}>
      <Step>
        <Instruction>Using SMS message</Instruction>

        <CellPhoneForm
          isActive={step === 0}
          submitText="Next"
          isSending={isSending}
          onSubmit={({ dialingCode, cellPhone: phoneNumber }) =>
            startChallenge(dialingCode, phoneNumber)
          }
        />
      </Step>

      <Step>
        <Instruction>Enter the verification code below</Instruction>

        <VerificationForm
          isActive={step === 1}
          isSending={isSending}
          onSubmit={({ verificationCode }) =>
            completeChallenge(verificationCode)
          }
        />
      </Step>
    </Slider>
  );
}

const Step = styled.div``;

const Instruction = styled.p`
  text-align: center;
  padding: ${px(0, 0, 32, 0)};
  line-height: 1;
  font-size: 16px;
  opacity: ${(p) => p.theme.disabledOpacity};
`;
